// Date 2021-09-28 15:21:04

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emWorkflowListView from "@/components/em/EmWorkflow/ListView";
import emWorkflowTaskView from "@/components/em/EmWorkflow/TaskView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
            {
            path: "/mintalMes/mst/mintalMesMstMaterial/list",
            name: "mintalMesMstMaterialList",
            component: emEntityListView,
                props: (route) => ({ prop_inline: '1' , prop_import: route.query.import , prop_export: route.query.export }),
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstMaterial/edit",
            name: "mintalMesMstMaterialEdit",
            component: emEntityEditView,
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstEquipment/list",
            name: "mintalMesMstEquipmentList",
            component: emEntityListView,
                props: (route) => ({ prop_inline: route.query.inline , prop_import: route.query.import , prop_export: route.query.export }),
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstEquipment/edit",
            name: "mintalMesMstEquipmentEdit",
            component: emEntityEditView,
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstEnergy/list",
            name: "mintalMesMstEnergyList",
            component: emEntityListView,
                props: (route) => ({ prop_inline: '1' , prop_import: route.query.import , prop_export: route.query.export }),
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstEnergy/edit",
            name: "mintalMesMstEnergyEdit",
            component: emEntityEditView,
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstFurnace/list",
            name: "mintalMesMstFurnaceList",
            component: emEntityListView,
                props: (route) => ({ prop_inline: route.query.inline , prop_import: route.query.import , prop_export: route.query.export }),
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstFurnace/edit",
            name: "mintalMesMstFurnaceEdit",
            component: emEntityEditView,
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstWarehouse/list",
            name: "mintalMesMstWarehouseList",
            component: emEntityListView,
                props: (route) => ({ prop_inline: route.query.inline , prop_import: route.query.import , prop_export: route.query.export }),
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstWarehouse/edit",
            name: "mintalMesMstWarehouseEdit",
            component: emEntityEditView,
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstPowerStationMeter/list",
            name: "mintalMesMstPowerStationMeterList",
            component: emEntityListView,
                props: (route) => ({ prop_inline: route.query.inline , prop_import: route.query.import , prop_export: route.query.export }),
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstPowerStationMeter/edit",
            name: "mintalMesMstPowerStationMeterEdit",
            component: emEntityEditView,
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstSubstationPoint/list",
            name: "mintalMesMstSubstationPointList",
            component: emEntityListView,
                props: (route) => ({ prop_inline: route.query.inline , prop_import: route.query.import , prop_export: route.query.export }),
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstSubstationPoint/edit",
            name: "mintalMesMstSubstationPointEdit",
            component: emEntityEditView,
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstGeneratorSet/list",
            name: "mintalMesMstGeneratorSetList",
            component: emEntityListView,
                props: (route) => ({ prop_inline: route.query.inline , prop_import: route.query.import , prop_export: route.query.export }),
            meta: metaObject
            },
            {
            path: "/mintalMes/mst/mintalMesMstGeneratorSet/edit",
            name: "mintalMesMstGeneratorSetEdit",
            component: emEntityEditView,
            meta: metaObject
            },

//自定义页面注册
]